import { render, staticRenderFns } from "./productService.vue?vue&type=template&id=36845e43&scoped=true"
import script from "./productService.vue?vue&type=script&lang=js"
export * from "./productService.vue?vue&type=script&lang=js"
import style0 from "./productService.vue?vue&type=style&index=0&id=36845e43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36845e43",
  null
  
)

export default component.exports